import type { PropsWithChildren } from 'react';
// biome-ignore lint/style/noRestrictedImports: using react-use timeout hook for delayed render
import { useTimeout } from 'react-use';

export default function DelayRender({ delay, children }: PropsWithChildren<{ delay: number }>) {
  const [isReady] = useTimeout(delay);

  return isReady() ? children : null;
}
